import { call, put } from 'redux-saga/effects';

import {
  getStaticChartData,
  getStaticBCBVData,
  npiDistributionAcrossCountry,
  getdDrgByHospitalCountWithNtype,
  getHospitalCountDrg,
  getDistingDRGByNegotiations,
  getProviderDrgByHospital,
  getstateDrgByHospital,
  getPCHcodeType,
  getPCHnegotiatedType,
  getPCHl1description,
  getPCHreportingEntity,
  getPCHcity,
  getPCHbillingCodeModifiers,
  getProcedureCostByHospital,
  getDrgReferenceTable
} from '../../services/dataAudit';
import {
  setStaticChartData,
  setSaticBCBVData,
  setStaticChartError,
  setSaticBCBVDataError,
  setNpiDistributionAcrossCountry,
  setNpiDistributionAcrossCountryError,
  setDrgByHospitalCountWithNtype,
  setDrgByHospitalCountWithNtypeError,
  setHospitalCountDrg,
  setHospitalCountDrgError,
  setDistingDrgByNegotiations,
  setDistingDrgByNegotiationsError,
  setProviderDrgByHospital,
  setProviderDrgByHospitalError,
  setStateDrgByHospital,
  setStateDrgByHospitalError,
  setPCHCodeType,
  setPCHCodeTypeError,
  setPCHNegotiatedType,
  setPCHNegotiatedTypeError,
  setPCHL1Description,
  setPCHL1DescriptionError,
  setPCHReportingEntity,
  setPCHReportingEntityError,
  setPCHCity,
  setPCHCityError,
  setPCHBillingCodeModifier,
  setPCHBillingCodeModifierError,
  setProcedureCostByHospital,
  setProcedureCostByHospitalError,
  setDrgReferenceTable,
  setDrgReferenceTableError
} from '../actions/dataAudit';

export function* getSaticChartDataSaga() {
  try {
    const response = yield call(getStaticChartData);
    if (response?.data) {
      yield put(setStaticChartData(response.data));
    }
  } catch (e) {
    yield put(setStaticChartError(e));
  }
}

export function* getSaticBCBVDataSaga() {
  try {
    const response = yield call(getStaticBCBVData);
    if (response?.data) {
      yield put(setSaticBCBVData(response.data));
    }
  } catch (e) {
    yield put(setSaticBCBVDataError(e));
  }
}

export function* npiAcrossCountrySaga(action) {
  try {
    const { payload } = action;
    const response = yield call(npiDistributionAcrossCountry, payload);
    if (response) {
      yield put(setNpiDistributionAcrossCountry(response.data));
    }
  } catch (e) {
    yield put(setNpiDistributionAcrossCountryError(e));
  }
}

export function* getdDrgByHospitalCountWithNtypeSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getdDrgByHospitalCountWithNtype, payload);
    if (response) {
      yield put(setDrgByHospitalCountWithNtype(response.data));
    }
  } catch (e) {
    yield put(setDrgByHospitalCountWithNtypeError(e));
  }
}

export function* getHospitalCountDrgSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getHospitalCountDrg, payload);
    if (response) {
      yield put(setHospitalCountDrg(response.data));
    }
  } catch (e) {
    yield put(setHospitalCountDrgError(e));
  }
}

export function* getDistingDRGByNegotiationsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getDistingDRGByNegotiations, payload);
    if (response) {
      yield put(setDistingDrgByNegotiations(response.data));
    }
  } catch (e) {
    yield put(setDistingDrgByNegotiationsError(e));
  }
}

export function* getProviderDrgByHospitalSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getProviderDrgByHospital, payload);
    if (response) {
      yield put(setProviderDrgByHospital(response.data));
    }
  } catch (e) {
    yield put(setProviderDrgByHospitalError(e));
  }
}

export function* getStateDrgByHospitalSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getstateDrgByHospital, payload);
    if (response) {
      yield put(setStateDrgByHospital(response.data));
    }
  } catch (e) {
    yield put(setStateDrgByHospitalError(e));
  }
}

export function* getPCHcodeTypeSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getPCHcodeType, payload);
    if (response) {
      yield put(setPCHCodeType(response.data));
    }
  } catch (e) {
    yield put(setPCHCodeTypeError, e);
  }
}

export function* getPCHnegotiatedTypeSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getPCHnegotiatedType, payload);
    if (response) {
      yield put(setPCHNegotiatedType(response.data));
    }
  } catch (e) {
    yield put(setPCHNegotiatedTypeError, e);
  }
}

export function* getPCHl1descriptionSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getPCHl1description, payload);
    if (response) {
      yield put(setPCHL1Description(response.data));
    }
  } catch (e) {
    yield put(setPCHL1DescriptionError, e);
  }
}

export function* getPCHreportingEntitySaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getPCHreportingEntity, payload);
    if (response) {
      yield put(setPCHReportingEntity(response.data));
    }
  } catch (e) {
    yield put(setPCHReportingEntityError, e);
  }
}

export function* getPCHcitySaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getPCHcity, payload);
    if (response) {
      yield put(setPCHCity(response.data));
    }
  } catch (e) {
    yield put(setPCHCityError, e);
  }
}

export function* getPCHbillingCodeModifiersSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getPCHbillingCodeModifiers, payload);
    if (response) {
      yield put(setPCHBillingCodeModifier(response.data));
    }
  } catch (e) {
    yield put(setPCHBillingCodeModifierError, e);
  }
}

export function* getProcedureCostByHospitalSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getProcedureCostByHospital, payload);
    if (response) {
      yield put(setProcedureCostByHospital(response.data));
    }
  } catch (e) {
    yield put(setProcedureCostByHospitalError, e);
  }
}

export function* getDrgReferenceTableSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getDrgReferenceTable, payload);
    if (response) {
      yield put(setDrgReferenceTable(response.data));
    }
  } catch (e) {
    yield put(setDrgReferenceTableError, e);
  }
}
